module.exports = __webpack_public_path__ + "img/puberty-decal-09.a6a19463.png";